import { render, staticRenderFns } from "./ArticleField.vue?vue&type=template&id=62153a65"
import script from "./ArticleField.vue?vue&type=script&lang=js"
export * from "./ArticleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports